import { render, staticRenderFns } from "./zIcon.vue?vue&type=template&id=63054384&scoped=true&"
import script from "./zIcon.vue?vue&type=script&lang=js&"
export * from "./zIcon.vue?vue&type=script&lang=js&"
import style0 from "./zIcon.vue?vue&type=style&index=0&id=63054384&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63054384",
  null
  
)

export default component.exports